import cn from 'classnames';
import { ArrowDownIcon, CheckHeavyAccent } from '#assets/ReactSvg.ts';
import { Menu, MenuButton, MenuItemCheck, MenuItemRadio, useMenuStore } from '#components/patterns/menus/menu/index.ts';
import type { PageSize } from '../types.ts';
import styles from './ResultsPerPage.module.css';

type Props = {
  value: PageSize;
  onSelect: (newValue: PageSize) => void;
  className?: string;
};

/**
 * {@link ResultsPerPage} allows the user to choose how many results to display in a table.
 */
export function ResultsPerPage({ value, onSelect, className }: Props) {
  const menu = useMenuStore({
    values: { resultsPerPage: value },
    setValues: (values) => {
      onSelect(values.resultsPerPage);
    },
  });
  return (
    <>
      <MenuButton store={menu} className={cn('menu-button', 'pad-16', styles.ResultsPerPage_button, className)}>
        {value} results per page
        <ArrowDownIcon className="ml-8" />
      </MenuButton>
      <Menu store={menu} className="menu-list ml-16">
        <ResultsChoice resultCount={15} value={value} />
        <ResultsChoice resultCount={25} value={value} />
        <ResultsChoice resultCount={50} value={value} />
        <ResultsChoice resultCount={100} value={value} />
        <ResultsChoice resultCount={250} value={value} />
        <ResultsChoice resultCount={500} value={value} />
      </Menu>
    </>
  );
}

function ResultsChoice({ resultCount, value }: { resultCount: PageSize; value: PageSize }) {
  return (
    <MenuItemRadio
      name="resultsPerPage"
      value={resultCount}
      hideOnClick={true}
      className={cn(styles.ResultsPerPage_menuItem, {
        [styles.ResultsPerPage_menuItem___isSelected]: value === resultCount,
      })}
    >
      <MenuItemCheck className={styles.ResultsPerPage_checkmark} style={{ width: 12, height: 12 }}>
        <CheckHeavyAccent height={12} width={12} />
      </MenuItemCheck>
      {resultCount} results
    </MenuItemRadio>
  );
}
